import { render, staticRenderFns } from "./ProjectFolder.vue?vue&type=template&id=c70f8372&"
import script from "./ProjectFolder.vue?vue&type=script&lang=js&"
export * from "./ProjectFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports